import { select, takeLatest, call, put } from 'redux-saga/effects';
import { postPatientInformationSuccess, postPatientInformationFailure, putPatientInformationSuccess, putPatientInformationFailure } from './slice';
import { postPatientEmergencyContactSuccess, postPatientEmergencyContactFailure } from '../patientEmergencyContactInfo/slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
import { uploadPatientFiles } from '../../../../utils/api';


function* postPatientInformationRequest(action) {
    try {
const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(apiPost, 'api/post-patient-information', action.payload);
        if (response.success) {
            if (action.payload.fileFormData) {
                const fileUploadRes = yield call(uploadPatientFiles, action.payload.fileFormData, currentBranch.id, response.pId);
                if (fileUploadRes?.data?.imagingStudies) {
                    response.imagingStudies = fileUploadRes?.data?.imagingStudies
                }
            } else {
                try {
                    const res = yield call(apiPost, 'api/post-patient-emergencyContact', { formData: action.payload, pId: response.pId, branchId: response.patientdata.branchId });
                    yield put(
                        postPatientEmergencyContactSuccess(res)
                    );
                } catch (err) {
                    yield put(
                        postPatientEmergencyContactFailure(err.message)
                    );
                }
            }
        }

        yield put(postPatientInformationSuccess(response));
    } catch (error) {
        yield put(postPatientInformationFailure(error?.response?.message || error));
    }
}

function* putPatientInformationRequest(action) {
    try {
const response = yield call(apiPut, `api/put-patient-information/${action.payload._id}`, action.payload);
        yield put(putPatientInformationSuccess(response));
    } catch (error) {
        yield put(putPatientInformationFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientInformation/postPatientInformationRequest', postPatientInformationRequest);
    yield takeLatest('patientInformation/putPatientInformationRequest', putPatientInformationRequest);
}

export default saga;